import { Component, OnInit, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import { IPaginationModel, IComponent, IPaginationComponent } from '../../interfaces';
@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements IComponent, IPaginationComponent, OnInit, OnChanges {
  // Implement IComponent
  name = 'PaginationComponent';
  subscriptions: Subscription[] = [];

  // Implement local variable
  @Input() MODEL: any;
  @Output() GetPage = new EventEmitter<number>(true);
  @Output() GetNext = new EventEmitter(true);
  @Output() GetPrev = new EventEmitter(true);
  @Output() Refresh = new EventEmitter(true);
  @Input() PAGES: number[];
  @Input() CURRENTPAGE: number;

  prevExist= false;
  nextExist=false;

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges() {
    'receiving model'.logWithObject(
      this.name, [this.MODEL, this.CURRENTPAGE, this.PAGES]);
    if (this.MODEL && this.PAGES && this.CURRENTPAGE) {
      this.setPageAvailability();
    }
  }

  getPage(i: number) {
    this.GetPage.emit(i);
  };

  getNext() {
    this.GetNext.emit();
  }

  getPrev() {
    this.GetPrev.emit();
  }

  OnRefresh() {
    this.Refresh.emit();
  }

  setPageAvailability(){
    if(this.CURRENTPAGE < this.PAGES.length){
      this.nextExist = true;
    }

    if(this.CURRENTPAGE > 1){
      this.prevExist = true;
    }
  }
}



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/components/pagination/pagination.component.ts